import { render } from "./AppTextarea.vue?vue&type=template&id=10df6c0a&scoped=true"
import script from "./AppTextarea.vue?vue&type=script&lang=js"
export * from "./AppTextarea.vue?vue&type=script&lang=js"

import "./AppTextarea.vue?vue&type=style&index=0&id=10df6c0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10df6c0a"]])

export default __exports__